import { Injectable, EventEmitter } from '@angular/core';
import { Observable, Subject, catchError, map, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  MYASSETS_DRIVERS_OFCUSTOMER,
  MYASSETS_FLEETS_OFCUSTOMER,
  MYASSETS_TEAMS_OFCUSTOMER,
  MYASSETS_VEHICLES_OFCUSTOMER,
  CUSTOMERS_BY_CUSTOMER_ENDPOINT,
  TRAILERS_BY_CUSTOMER_ENDPOINT,
  CUSTOMERS_BY_CUSTOMER_ENDPOINT_20,
  MYASSETS_VEHICLES_OFCUSTOMER_20,
  MYASSETS_DRIVERS_OFCUSTOMER_20,
  VEHICLE_FILTER_INCLUDE_CHILDREN,
  VEHICLE_FILTER_ALSO_DISABLED,
  VEHICLE_FILTER_ALSO_DATA_HIDDEN,
  VEHICLE_FILTER_SUBSCRIBED,
  VEHICLE_FILTER_HAVE_COMMUNICATED

} from 'src/app/core/config/config.constants';
import { DataService } from 'src/app/core/services/data.service';
import * as _ from 'lodash';
import { FilterOptions } from 'src/app/core/models/filterOptions';


@Injectable({
  providedIn: 'root'
})
export class FilterRefService {
  constructor(private http: HttpClient,
              private dataService: DataService) {

  }

  baseApi = environment.baseApi;
   tsohwapi = environment.baseTsOhwUrl;

  //selectedCustomer = this.getSelectedCustomer()?.uid;
  filterRefChangeEvent = new EventEmitter<FilterOptions | null>();

  getFleetsOfCustomers$(uidCustomer): Observable<any> {
    return this.http
      .get<any>(
        this.baseApi + MYASSETS_FLEETS_OFCUSTOMER + uidCustomer
      )
      .pipe(
        map((Payload) => {
          //console.log(Payload)
          // this.setSessionFleetsOfCustomers$(Payload)
          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }

  // getDriversOfCustomers$(uidCustomer): Observable<any> {
  //   return this.http
  //     .get<any>(
  //       this.baseApi + MYASSETS_DRIVERS_OFCUSTOMER + uidCustomer
  //     )
  //     .pipe(
  //       map((Payload) => {
  //         //console.log(Payload)
  //         //console.log('Payload',Payload)

  //         // sort by fullName
  //         Payload.sort((a, b) => {
  //             const fullNameA = a.fullName.toUpperCase(); // ignore upper and lowercase
  //             const fullNameB = b.fullName.toUpperCase(); // ignore upper and lowercase
  //             if (fullNameA < fullNameB) {
  //               return -1;
  //             }
  //             if (fullNameA > fullNameB) {
  //               return 1;
  //             }

  //             // names must be equal
  //             return 0;
  //           });


  //         // this.setSessionDriversOfCustomers$(Payload)
  //         return Payload;
  //       }),
  //       catchError((err: any) => {
  //         return err;
  //       })
  //     );
  // }



  getDriversOfCustomers_20$(uidCustomer: string): Observable<any> {
    return this.http
      .get<any>(
        this.tsohwapi + MYASSETS_DRIVERS_OFCUSTOMER_20 + uidCustomer
      )
      .pipe(
        map((Payload) => {
          //console.log('Payload',Payload)

          // Add fullName property to each driver
          Payload.forEach(driver => {
            driver.fullName = `${driver.firstName} ${driver.lastName}`;
          });

          // sort by fullName
          Payload.sort((a, b) => {
              const fullNameA = a.fullName.toUpperCase(); // ignore upper and lowercase
              const fullNameB = b.fullName.toUpperCase(); // ignore upper and lowercase
              if (fullNameA < fullNameB) {
                return -1;
              }
              if (fullNameA > fullNameB) {
                return 1;
              }

              // names must be equal
              return 0;
            });

          // this.setSessionDriversOfCustomers$(Payload)
          return Payload;
        }),
        catchError((err: any) => {
          console.error('Error loading drivers:', err);
          return of([]);
        })
      );
  }

  getTeamsOfCustomers$(uidCustomer): Observable<any> {
    return this.http
      .get<any>(
        this.baseApi + MYASSETS_TEAMS_OFCUSTOMER + uidCustomer
      )
      .pipe(
        map((Payload) => {
          //console.log(Payload)
          // this.setSessionTeamsOfCustomers$(Payload)
          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }

  // getVehiclesOfCustomers$(uidCustomer ): Observable<any> {
  //   return this.http
  //     .get<any>(
  //       this.baseApi + MYASSETS_VEHICLES_OFCUSTOMER + uidCustomer
  //     )
  //     .pipe(
  //       map((Payload) => {
  //        // console.log(Payload)
  //          //sort by plate
  //          Payload.sort((a, b) => {
  //           const plateA = a.plate.toUpperCase(); // ignore upper and lowercase
  //           const plateB = b.plate.toUpperCase(); // ignore upper and lowercase
  //           if (plateA < plateB) {
  //             return -1;
  //           }
  //           if (plateA > plateB) {
  //             return 1;
  //           }

  //           // plate must be equal
  //           return 0;
  //         });

  //         // this.setSessionVehiclesOfCustomers$(Payload);

  //         return Payload;
  //       }),
  //       catchError((err: any) => {
  //         return err;
  //       })
  //     );
  // }



   getVehiclesOfCustomers_20AllFilter$(uidCustomer: string): Observable<any> {
    // Build query params with default values from constants
    const params: any = {
      alsoDisabled: VEHICLE_FILTER_ALSO_DISABLED,
      includeChildren: VEHICLE_FILTER_INCLUDE_CHILDREN,
      subscribed: VEHICLE_FILTER_SUBSCRIBED,
      alsoDataHidden: VEHICLE_FILTER_ALSO_DATA_HIDDEN,
      haveCommunicated: VEHICLE_FILTER_HAVE_COMMUNICATED
    };

    return this.http
      .get<any>(
        this.tsohwapi + MYASSETS_VEHICLES_OFCUSTOMER_20 + uidCustomer,
        { params }
      )
      .pipe(
        map((Payload) => {
           //console.log('ZAK - ' ,Payload)
           //sort by plate
           Payload.sort((a, b) => {
            const plateA = a.plate.toUpperCase(); // ignore upper and lowercase
            const plateB = b.plate.toUpperCase(); // ignore upper and lowercase
            if (plateA < plateB) {
              return -1;
            }
            if (plateA > plateB) {
              return 1;
            }

            // plate must be equal
            return 0;
          });

          // this.setSessionVehiclesOfCustomers$(Payload);

          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }


   getVehiclesOfCustomers_20$(uidCustomer: string, filters?: {
    alsoDisabled?: boolean,
    includeChildren?: boolean,
    subscribed?: boolean,
    alsoDataHidden?: boolean,
    haveCommunicated?: boolean
  }): Observable<any> {
    // Build query params
    const params: any = {};
    if (filters) {
      if (filters.alsoDisabled !== undefined) params.alsoDisabled = filters.alsoDisabled;
      if (filters.includeChildren !== undefined) params.includeChildren = filters.includeChildren;
      if (filters.subscribed !== undefined) params.subscribed = filters.subscribed;
      if (filters.alsoDataHidden !== undefined) params.alsoDataHidden = filters.alsoDataHidden;
      if (filters.haveCommunicated !== undefined) params.haveCommunicated = filters.haveCommunicated;
    }

    return this.http
      .get<any>(
        this.tsohwapi + MYASSETS_VEHICLES_OFCUSTOMER_20 + uidCustomer,
        { params }
      )
      .pipe(
        map((Payload) => {
           //console.log('ZAK - ' ,Payload)
           //sort by plate
           Payload.sort((a, b) => {
            const plateA = a.plate.toUpperCase(); // ignore upper and lowercase
            const plateB = b.plate.toUpperCase(); // ignore upper and lowercase
            if (plateA < plateB) {
              return -1;
            }
            if (plateA > plateB) {
              return 1;
            }

            // plate must be equal
            return 0;
          });

          // this.setSessionVehiclesOfCustomers$(Payload);

          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }
  getTrailersOfCustomers$(uidCustomer): Observable<any> {
    return this.http
      .get<any>(
        this.baseApi + TRAILERS_BY_CUSTOMER_ENDPOINT + "/" + uidCustomer
      )
      .pipe(
        map((Payload) => {
          //sort by plate
          Payload.sort((a, b) => {
            const plateA = a.plate.toUpperCase(); // ignore upper and lowercase
            const plateB = b.plate.toUpperCase(); // ignore upper and lowercase
            if (plateA < plateB) {
              return -1;
            }
            if (plateA > plateB) {
              return 1;
            }

            // plate must be equal
            return 0;
          });
          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }



  // getCustomers$(): Observable<any> {
  //   let userInfo = this.dataService.getCurrentUserInfo();
  //   return this.http
  //     .get<any>(
  //       this.baseApi +
  //         CUSTOMERS_BY_CUSTOMER_ENDPOINT +
  //         '/' +
  //         userInfo.customer.uid
  //     )
  //     .pipe(
  //       map((Payload) => {
  //         //console.log(Payload)
  //         this.updateCustomerListWithChildrenInfo(Payload);
  //         // this.setSessionCustomers$(Payload)
  //         return Payload;
  //       }),
  //       catchError((err: any) => {
  //         return err;
  //       })
  //     );
  // }


   getCustomers_20$(): Observable<any> {
    let userInfo = this.dataService.getCurrentUserInfo();
    return this.http
      .get<any>(
        this.tsohwapi +
          CUSTOMERS_BY_CUSTOMER_ENDPOINT_20 +
          '/' +
          userInfo.customer.uid
      )
      .pipe(
        map((Payload) => {
         //console.log('ZAK- ' ,Payload)
          this.updateCustomerListWithChildrenInfo(Payload);
          // this.setSessionCustomers$(Payload)
          return Payload;
        }),
        catchError((err: any) => {
          return err;
        })
      );
  }





  updateCustomerListWithChildrenInfo(customerList: any) {
    let self = this;

    for (let customer of customerList) {
      var childrens;

      // Not root
      if (customer.uidParent !== null) {
        var customerParent = _.find(customerList, { uid: customer.uidParent });
        // Controlla se il parent esiste nella lista prima di assegnare
        if (customerParent) {
          childrens = _.filter(customerList, { uidParent: customer.uidParent });
          customerParent.nameWithChildren =
            customerParent.name + ' (' + childrens.length + ')';
        }
      } else {
        // Root customer
        childrens = _.filter(customerList, { uidParent: customer.uid });
        customer.nameWithChildren =
          customer.name + ' (' + childrens.length + ')';
      }
      if (!customer.nameWithChildren) customer.nameWithChildren = customer.name;
    }
    return customerList;
  }



  // private setSessionCustomers$(dataIn) {
  //   sessionStorage.setItem('Customers$', JSON.stringify(dataIn));
  // }

  // getSessionCustomers$() {
  //   return JSON.parse(sessionStorage.getItem('Customers$')|| '0');
  // }

  // private setSessionVehiclesOfCustomers$(dataIn) {
  //   sessionStorage.setItem('VehiclesOfCustomers$', JSON.stringify(dataIn));
  // }

  // getSessionVehiclesOfCustomers$() {
  //   return JSON.parse(sessionStorage.getItem('VehiclesOfCustomers$') || '0');
  // }

  // private setSessionDriversOfCustomers$(dataIn) {
  //   sessionStorage.setItem('DriversOfCustomers$', JSON.stringify(dataIn));
  // }

  // getSessionDriversOfCustomers$() {
  //   return JSON.parse(sessionStorage.getItem('VehiclesOfCustomers$') || '0');
  // }

  // private setSessionFleetsOfCustomers$(dataIn) {
  //   sessionStorage.setItem('FleetsOfCustomers$', JSON.stringify(dataIn));
  // }

  // getSessionFleetsOfCustomers$() {
  //   return JSON.parse(sessionStorage.getItem('FleetsOfCustomers$') || '0');
  // }

  // private setSessionTeamsOfCustomers$(dataIn) {
  //   sessionStorage.setItem('TeamsOfCustomers$', JSON.stringify(dataIn));
  // }

  // getSessionTeamsOfCustomers$() {
  //   return JSON.parse(sessionStorage.getItem('TeamsOfCustomers$') || '0');
  // }

  //gestione eventi del filtro

  // initFilterRef(
  //   options: FilterOptions | null,
  //   isRefreshed?: boolean,
  //   firstTabOption?: string,
  //   timespanSel?: string
  // ){
  //   this.filterRefChangeEvent.emit(options);
  // }






}
